import { ProductId } from "./index";
import emailSpellChecker from "@zootools/email-spell-checker";

export interface ErrorReportResponse {
	success: boolean,
	reason?: string
}

export abstract class SettingsDataSource<P extends ProductId> {
	private fontSize: number;
	private keyboard: boolean;
	private timer: boolean;
	private randomize: boolean;
	private errors: (Error | any)[];

	constructor() {
		this.keyboard = true;
		this.timer = true;
		this.fontSize = 1;
		this.randomize = false;
		this.errors = [];
	}

	getKeyboardShortcuts(): boolean { return this.keyboard; }
	setKeyboardShortcuts(enabled: boolean): void { this.keyboard = enabled; }

	getFontSize(): number { return this.fontSize }
	setFontSize(size: number): void { this.fontSize = size; }

	getRandomize(): boolean { return this.randomize; }
	setRandomize(randomize: boolean): void { this.randomize = randomize; }

	toggleTimer(): boolean {
		this.timer = !this.timer;
		return this.timer;
	}

	getEmailSuggestion(email: string): Promise<string | undefined> {
		const suggestion = emailSpellChecker.run({ email });
		return Promise.resolve(suggestion ? suggestion.full : undefined);
	}

	abstract sendErrorReport(product: P, form: HTMLFormElement): Promise<ErrorReportResponse>

	appendError(error: Error | any): void {
		this.errors.push(error);
	}

	getErrors(): (Error | any)[] {
		return this.errors;
	}

	clearErrors(): void {
		this.errors = [];
	}

	abstract getLocalStoragePrefix(): RegExp;

	getLocalStorage(prefix: RegExp): Record<string, any> {
		return Array.from(Array(window.localStorage.length).keys())
			.map(i => window.localStorage.key(i))
			.filter(key => prefix.test(key))
			.reduce((result, key) => ({
				...result,
				[key]: (content => {
					try { return JSON.parse(content); }
					catch(e) { return content; }
				})(window.localStorage.getItem(key))
			}), {});
	}
}

export class NullSettingsDataSource<P extends ProductId> extends SettingsDataSource<P> {
	sendErrorReport(product: P, form: HTMLFormElement): Promise<ErrorReportResponse> {
		throw new Error("Method not implemented.");
	}

	getLocalStoragePrefix(): RegExp {
		throw new Error("Method not implemented.");
	}
}